import React, { FC } from 'react'
import { CTAWrapper } from './style'

//* utils
import { ModuleNames } from '../../../constants/componentNames.constants'
import { internalLinkHandler } from '../../../utils/link.utils'

//* components
import Button from '../../global/button'
import ContentBlock from '../../global/contentBlock'
import ContentColumns from '../../global/contentColumns'
import ContentRows from '../../global/contentRows'
import GlobalContainer from '../../global/globalContainer'
import Grid from '../../global/grid'
import Hero from '../../global/hero'
import MainCTA from '../../global/mainCta'
import ParagraphBlock from '../../global/paragraphBlock'
import ResourceRow from '../../global/resourceRow'
import SEOTags from '../../global/seoTags'
import Table from '../../global/table'
import Tiles from '../../global/tiles'

type Props = {
  data: any
  defaultLocale: string
  availableLocales: any
  location: any
}

export const Modules: FC<Props> = ({ data, defaultLocale, availableLocales, location }) => {
  const dynamicPageContent = data.flexSection.map((module: any, i: number) => {
    switch (module.__typename) {
      case ModuleNames.GLOBAL_MAIN_CTA:
        return <MainCTA data={module} key={`legalPageModule--${i}`} />

      case ModuleNames.PARAGRAPH_BLOCK:
        return <ParagraphBlock data={module} key={`legalPageModule--${i}`} />

      case ModuleNames.CONTENT_ROWS:
        return <ContentRows data={module} key={`legalPageModule--${i}`} />

      case ModuleNames.GLOBAL_CONTENT_COLUMNS:
        return <ContentColumns data={module} pageType="legal" key={`legalPageModule--${i}`} />

      case ModuleNames.GLOBAL_CONTENT_BLOCK:
        return <ContentBlock data={module} key={`legalPageModule--${i}`} />

      case ModuleNames.RESOURCE_ROW:
        return (
          <ResourceRow
            data={module}
            pageType="legal"
            key={`legalPageModule--${i}`}
            locale={defaultLocale}
          />
        )

      case ModuleNames.TILES:
        return <Tiles data={module} key={`legalPageModule--${i}`} />

      case ModuleNames.GRID:
        return <Grid data={module} key={`legalPageModule--${i}`} />

      case ModuleNames.TABLE:
        return <Table data={module} key={`legalPageModule--${i}`} />

      case ModuleNames.TOPIC_CTA:
        const buttonHref = module.internalLink
          ? internalLinkHandler(module.internalLink)
          : module.externalUrl

        return (
          <CTAWrapper>
            {module.buttonId === 'ot-sdk-btn' ? (
              <Button
                key={`legalPageModule--${i}`}
                theme="light"
                type="primary"
                buttonId="ot-sdk-btn"
                className="ot-sdk-show-settings"
              />
            ) : (
              <Button
                key={`legalPageModule--${i}`}
                icon={false}
                href={buttonHref}
                type="primary"
                text={module.text}
                size="small"
                buttonId={module.buttonId}
                theme={'light'}
              />
            )}
          </CTAWrapper>
        )
    }
  })

  return (
    <div data-cy="Legalpage">
      <SEOTags
        seoMetadata={data.seoMetadata}
        slug={''}
        locale={defaultLocale}
        siteSection="Legal Page"
        availableLocales={availableLocales}
      />

      {data.hero && (
        <Hero
          data={data.hero}
          location={location}
          pageTitle={data.name}
          showBreadcrumbs={true}
          isHomePage={false}
          pageType="legal"
          breadcrumb={data.breadcrumb}
        />
      )}

      {dynamicPageContent}

      {data.useCase === 'Cookie Policy' && (
        <GlobalContainer>
          <div id="ot-sdk-cookie-policy"></div>
        </GlobalContainer>
      )}
    </div>
  )
}
